import React, { useContext } from 'react'
import { store } from '../../stores/multipost'
import { Button } from 'reactstrap'
import SocialAccountProvider from './socialAccountProvider'
import pluralize from 'pluralize'


export default function SubmitButton() {
  const { selectedAccounts, selectedFiles, messages, scheduled, submitting } = useContext(store)

  let postCount = 0
  let accountCount = 0
  let postDescriptions = []

  selectedAccounts.forEach(account => {
    let result = SocialAccountProvider.find(account).postCount(selectedFiles, messages)
    postCount += result.postCount
    if(result.postCount > 0) {
      postDescriptions.push(...result.postDescriptions)
      accountCount++
    }
  })

  const tooManyAssets = selectedAccounts.some(account => SocialAccountProvider.find(account).tooManyAssets(selectedFiles))
  const messagesOverLength = selectedAccounts.some(account => SocialAccountProvider.find(account).messageOverLength(messages[account]?.value || messages.default.value))

  const disabled = postCount === 0 || submitting || tooManyAssets || messagesOverLength

  let content

  if(selectedAccounts.length === 0) {
    content = "Select at least one account"
  } else if (postCount === 0) {
    content = "Select a file or add a message"
  } else if (messagesOverLength) {
    content = "Your message is too long"
  } else {
    content = [scheduled ? 'Schedule' : 'Send', pluralize('Post', postCount, true), 'to', pluralize('Account', accountCount, true)].join(' ')
  }

  return (
    <div className="mb-4">
    <Button color="primary" size="lg" className="w-100 mb-2" type="submit" disabled={disabled}>
      {content}
    </Button>
    {postDescriptions.length > 0 && (
      <p className="text-muted">
        {postDescriptions.join(", ")}
      </p>
    )}
    </div>
  )
}